import React from "react";
import TripForm from "./TripForm";

export default function TripsFixas() {
    return (
        <TripForm
            tipo="fixo"
            title="Contratos de Veículos"
            subtitle="Registro das viagens realizadas por veículos contratados fixos"
        />
    );
}
